import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-compliance',
  templateUrl: './compliance.page.html',
  styleUrls: ['./compliance.page.scss']
})
export class CompliancePage implements OnInit {
  constructor(public modalController: ModalController) {}

  ngOnInit() {}

  async closeModal() {
    await this.modalController.dismiss()
  }
}
